/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsCreate } from "../../funcs/llmConversationsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsCreateRequest$inboundSchema,
};

export const tool$llmConversationsCreate: ToolDefinition<typeof args> = {
  name: "llm-conversations-create",
  description: `Create a conversation

Create a conversation to store and retrieve conversation state across Response API calls.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
